import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const STORE_KEY = "caseirinho_via";
const DEFAULT_COOKIE_DAYS = 30;

// Captura o parâmetro ?via= a partir de uma query string.
// Idempotente: um refresh ou navegação repetida no mesmo caminho+código não regista cliques duplicados.
export function captureVia(search, pathname = "/") {
    try {
        const params = new URLSearchParams(search || "");
        const via = params.get("via");
        if (!via) return;
        const code = via.trim().toLowerCase();
        if (!code) return;

        // Preserva a atribuição existente (last-click) e renova o timestamp.
        try {
            const prev = JSON.parse(localStorage.getItem(STORE_KEY) || "null");
            const cookieDays = (prev && prev.code === code && prev.cookieDays) || DEFAULT_COOKIE_DAYS;
            localStorage.setItem(STORE_KEY, JSON.stringify({ code, ts: Date.now(), cookieDays }));
        } catch { /* ignore */ }

        // Idempotência dos cliques: só regista uma vez por (código + caminho) por sessão.
        const guardKey = `via_click_${code}_${pathname}`;
        let alreadyTracked = false;
        try { alreadyTracked = sessionStorage.getItem(guardKey) === "1"; } catch { /* ignore */ }
        if (alreadyTracked) return;
        try { sessionStorage.setItem(guardKey, "1"); } catch { /* ignore */ }

        fetch(`${BACKEND}/api/affiliate/track`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code, path: pathname }),
        })
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
                if (data && data.cookie_days) {
                    try {
                        const cur = JSON.parse(localStorage.getItem(STORE_KEY) || "null");
                        if (cur && cur.code === code) {
                            localStorage.setItem(STORE_KEY, JSON.stringify({ ...cur, cookieDays: data.cookie_days }));
                        }
                    } catch { /* ignore */ }
                }
            })
            .catch(() => {});
    } catch { /* ignore */ }
}

// Componente montado dentro do Router: captura ?via= em cada navegação (incl. deep links SPA).
export default function AffiliateTracker() {
    const location = useLocation();
    useEffect(() => {
        captureVia(location.search, location.pathname);
    }, [location.search, location.pathname]);
    return null;
}

// Helper reutilizável: devolve o código de afiliado ainda válido (dentro da janela cookie_days).
export function getAffiliateCode(fallbackDays = DEFAULT_COOKIE_DAYS) {
    try {
        const raw = localStorage.getItem(STORE_KEY);
        if (!raw) return null;
        const { code, ts, cookieDays } = JSON.parse(raw);
        const maxDays = cookieDays || fallbackDays;
        if (Date.now() - ts > maxDays * 24 * 60 * 60 * 1000) return null;
        return code || null;
    } catch { return null; }
}
